<template>
  <blocks-and-alerts :child-id="id" />
</template>

<script>
  import BlocksAndAlerts from '@/components/Child/ChildTabs/TabBlocksAndAlerts/BlocksAndAlerts.vue'

  export default {
    props: {
      id: {
        required: true
      }
    },

    components: {
      BlocksAndAlerts
    }
  }
</script>
